// ─── Environment Variables ────────────────────────────────────────────────────

const EXPLORER = process.env.NEXT_PUBLIC_BLOCKCHAIN_EXPLORER_URL || ''

// ─── Types ──────────────────────────────────────────────────────────────────

export type TxStatus = 'not-started' | 'started' | 'processing' | 'completed' | 'failed'

export interface LedgerTx {
  label: string
  status: TxStatus
  txHash?: string
  explorerUrl?: string
}

// ─── Constants ──────────────────────────────────────────────────────────────

/** Stream ID used for the current live stream ledger entry */
export const LIVE_STREAM_LEDGER_ID = 'live-stream'

// ─── Helpers ────────────────────────────────────────────────────────────────

/** Build a block-explorer link for a TX hash, with optional per-stream override. */
export function explorerTxUrl(txHash: string, baseUrl?: string | null): string | undefined {
  const explorer = baseUrl ?? EXPLORER
  return explorer ? `${explorer}/tx/${txHash}` : undefined
}

/** Human-readable label for a TX status, shown on the ledger card. */
export function txStatusLabel(status: TxStatus): string {
  switch (status) {
    case 'not-started': return 'AWAITING...'
    case 'started':     return 'VERIFICATION STARTED'
    case 'processing':  return 'TRANSACTION PROCESSING'
    case 'completed':   return 'TRANSACTION COMPLETED'
    case 'failed':      return 'TRANSACTION ISSUE — PLEASE WAIT FOR UPDATES'
  }
}

/** Format a stream date for the ledger card header. */
export function formatLedgerDate(iso: string): string {
  return new Date(iso).toLocaleString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
    hour12: false,
  })
}
